module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-460x295.df1cf677.jpg";